<template>
    <div class="centerWidth">
        <div class="gaokao">
            <div class="gaokao-nav">
                <span @click="goMyCenter">个人中心 > </span>
                <span>{{info.Name}}</span>
            </div>
            <section
                class="gaokao-content"
                v-if="info"
            >
                <div class="my-title">{{info.Title}}</div>
                <div class="gaokao-con">
                    <p style="white-space: pre-wrap;">{{info.Description}}</p>
                </div>
                <div class="gaokao-notice">
                    <p class="gk-notice-tit">考前须知</p>
                    <ul class="gk-notice-li">
                        <li style="white-space: pre-wrap;">{{info.Notice}}</li>
                    </ul>
                </div>
                <button
                    class="gaokao-btn"
                    @click="goTesta"
                >开始测试</button>
            </section>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            info: {}
        };
    },
    created() {
        this.getEvaluationDesc();
    },
    methods: {
        // 个人中心
        goMyCenter() {
            this.$router.push('/myIndex');
        },

        // 获取测评简介
        getEvaluationDesc() {
            this.$api.getEvaluationDesc(this.$route.query).then(res => {
                this.info = res.data;
                document.title = res.data.Name || '测评';
            });
        },
        // 测试
        goTesta() {
            // eslint-disable-next-line eqeqeq
            if (this.$route.query.id == 13) {
                this.$router.push({
                    path: '/locationtest',
                    query: {
                        ...this.$route.query,
                        name: this.info.Name
                    }
                });
            } else {
                this.$router.push({
                    path: '/styletest',
                    query: {
                        ...this.$route.query,
                        name: this.info.Name
                    }
                });
            }
        }
    }
};
</script>

<style scoped>
.gaokao {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.gaokao-nav {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
}
.gaokao-nav span {
    font-size: 15px;
    color: #333;
}
.gaokao-nav span:last-child {
    color: #333;
}
/* gaokao-content */
.gaokao-content {
    padding: 0 20px;
    width: 100%;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 25px;
}
.gaokao-con {
    padding: 50px 20px;
    height: auto;
    overflow: hidden;
}
.gaokao-con p {
    font-size: 14px;
    color: #333;
    text-indent: 2em;
    line-height: 28px;
}
/* gaokao-notice */
.gaokao-notice {
    width: 100%;
    padding: 0 40px 40px 40px;
    height: auto;
    overflow: hidden;
    background-color: #eee;
}
.gk-notice-tit {
    font-size: 17px;
    color: #333;
    padding: 40px 0;
}
.gk-notice-li {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.gk-notice-li li {
    font-size: 15px;
    color: #333;
    padding-bottom: 15px;
}
.gk-notice-li li:last-child {
    padding-bottom: 0px;
}
.gaokao-btn {
    width: 200px;
    height: 40px;
    background-color: #333;
    border-radius: 6px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    margin: 50px auto;
    display: block;
}
</style>
